// В src/pages/ReportsPage.jsx
import React, { useState } from "react";
import styles from "./ReportsPage.module.css";
import SummaryReport from "./components/reports/SummaryReport";
// import OtherReport from "../components/reports/OtherReport";

const ReportsPage = () => {
  const [selected, setSelected] = useState("summary");

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.title}>Панель отчётов</h1>
      </header>
      <nav className={styles.nav}>
        <button
          className={`${styles.navButton} ${
            selected === "summary" ? styles.active : ""
          }`}
          onClick={() => setSelected("summary")}
        >
          Итоги по квитанциям
        </button>
        <button
          className={`${styles.navButton} ${
            selected === "other" ? styles.active : ""
          }`}
          onClick={() => setSelected("other")}
        >
          Другой отчёт
        </button>
      </nav>
      <main className={styles.content}>
        {selected === "summary" && <SummaryReport />}
        {selected === "other" && (
          <div className={styles.placeholder}>Здесь будет другой отчёт</div>
        )}
      </main>
    </div>
  );
};

export default ReportsPage;
